/*
 *
 * ProtectionPlusModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
*/

import ProtectionPlusModal from './ProtectionPlusModalContainer'

export default ProtectionPlusModal
